module.exports = __webpack_public_path__ + "img/slideshow-one.f85e5459.jpg";